<div class="row">
  <div class="col">
    <input
      #d="ngbDatepicker"
      (change)="emitEvent($event)"
      (dateSelect)="emitEvent($event)"
      [(ngModel)]="model"
      [maxDate]="maxDate"
      [minDate]="minDate"
      class="form-control input-heighten-adjustment"
      name="dp"
      ngbDatepicker
      placeholder="mm-dd-yyyy"
    />
  </div>
  <div class="col-auto calendar-margin-left">
    <button
      (click)="d.toggle()"
      class="btn btn-lg btn-outline-secondary"
      type="button"
    >
      <i aria-hidden="true" class="fa fa-calendar"></i>
    </button>
  </div>
</div>
